import { render, staticRenderFns } from "./StructureInfo.vue?vue&type=template&id=3d2dfcd8&scoped=true&"
import script from "./StructureInfo.vue?vue&type=script&lang=js&"
export * from "./StructureInfo.vue?vue&type=script&lang=js&"
import style0 from "./StructureInfo.vue?vue&type=style&index=0&id=3d2dfcd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2dfcd8",
  null
  
)

export default component.exports